export default __webpack_public_path__ + "static/media/apbutton.99ae1044.svg";